import React from 'react';
import styled, { ThemeProvider } from 'styled-components';
import { DefaultTheme } from '../../Themes';
const StyledContainer = styled.div `
  display: inline-flex;
  padding: 1rem;
  background-color: ${({ theme }) => theme.ThemeColors.SURFACE.hex};
  border-radius: 4px;
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.08), 0 1px 4px rgba(0, 0, 0, 0.12);
  box-sizing: border-box;
  cursor: ${({ clickable }) => clickable ? 'pointer' : 'default'};
`;
const Card = ({ children, className, onClick, theme = DefaultTheme, }) => (React.createElement(ThemeProvider, { theme: theme },
    React.createElement(StyledContainer, { className: className, clickable: !!onClick, onClick: onClick }, children)));
export default Card;
